module.exports = __webpack_public_path__ + "img/Feature.e5b487f4.png";